(function () {
  angular
    .module("akitabox.ui.dialogs.room.delete")
    .factory("DeleteRoomDialog", DeleteRoomDialog);

  /* @ngInject */
  function DeleteRoomDialog($log, $q, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl: "app/core/ui/dialogs/room/delete/delete-room.dialog.html",
      controller: "DeleteRoomDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.roomIDs` and `options.locals.building` are required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error}               Promise that resolves with the deleted rooms
     */
    function show(options) {
      // Verify we have roomIDs and building locals
      if (
        !options ||
        !options.locals ||
        !options.locals.roomIDs ||
        !(options.locals.building || options.locals.buildingId)
      ) {
        $log.error(
          "DeleteRoomDialog: you must pass in roomIDs and building via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
